import i18n from "../../constants/i18n";
import { searchImageWithGoogleLens } from "../../helpers/et3-search-google-lens";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import { TEt3Image } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Tooltip from "../et3-tooltip";

const Et3Image = withLiteObserverAndTheme<TEt3Image>((props) => {
  const { imageName, alt, size, style, onClick, theme, type } = props;
  const { unitX } = theme;
  const isButtonLocked = getCoreUIStore().buttonLocked.get();
  const isOnlineType = type === "ONLINE";
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const googleLensFeatureIsEnabled = isOnlineType && !isAnyKhattabaAdmin;

  return (
    <Et3Tooltip
      title={
        googleLensFeatureIsEnabled
          ? `${i18n.get("DOUBLE_CLICK_FOR_GOOGLE_LENS")}`
          : ""
      }
      placement="top"
    >
      <img
        src={
          isOnlineType
            ? `${imageName}`
            : require(`../../assets/images/${imageName}.png`)
        }
        alt={alt}
        style={{
          cursor: isOnlineType ? "pointer" : "default",
          height: "auto",
          width: size * unitX,
          pointerEvents: isButtonLocked ? "none" : "auto",
          ...style
        }}
        onDoubleClick={() => {
          if (googleLensFeatureIsEnabled) {
            searchImageWithGoogleLens(imageName);
          } else {
            return;
          }
        }}
        onClick={async () => {
          getCoreUIStore().buttonLocked.set(true);
          await onClick();
          getCoreUIStore().buttonLocked.set(false);
        }}
      />
    </Et3Tooltip>
  );
});
export default Et3Image;
